// Calculate points based on ranking (higher rank = more points)
export function calculatePoints(ranking: number, totalPlayers: number): number {
  const basePoints = 1000
  const pointsPerRank = 50
  return basePoints + (totalPlayers - ranking) * pointsPerRank
}

// Generate mock W-L record based on ranking
export function generateRecord(ranking: number, totalPlayers: number): { wins: number; losses: number } {
  const maxGames = 15
  const winRate = (totalPlayers - ranking + 1) / totalPlayers
  const wins = Math.round(maxGames * winRate * (0.8 + Math.random() * 0.4))
  const losses = Math.round((maxGames - wins) * (0.5 + Math.random() * 0.5))
  return { wins: Math.max(0, wins), losses: Math.max(0, losses) }
}

export function formatDate(dateString: string): string {
  return new Date(dateString + 'T00:00:00').toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })
}

export function formatCurrency(amountInSmallestUnit: number, currency: string): string {
  const amount = amountInSmallestUnit / 100
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: currency,
  }).format(amount)
}

export function getInitials(name: string): string {
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
}
